// The Overview summary card, shared by a project and a place (owner, 2026-09-20): one outlined card of
// icon + label + value rows, where a figure is a link into the tab that holds its detail. Extracted from
// ProjectDetails so a warehouse's Overview tells the same story in the same shape.
import { Link, Paper, Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';

export function SummaryCard({
  title,
  testId,
  children,
}: {
  title: string;
  testId?: string;
  children: ReactNode;
}) {
  return (
    <Paper variant="outlined" sx={{ p: 2, mb: 2 }} data-testid={testId}>
      <Typography variant="subtitle1" component="h2" sx={{ fontWeight: 600, mb: 1.5 }}>
        {title}
      </Typography>
      <Stack spacing={1.5}>{children}</Stack>
    </Paper>
  );
}

export function SummaryRow({
  icon,
  label,
  children,
}: {
  icon: ReactNode;
  label: string;
  children: ReactNode;
}) {
  return (
    <Stack direction="row" spacing={1.5} alignItems="flex-start">
      <Stack sx={{ color: 'text.secondary', pt: 0.25 }}>{icon}</Stack>
      <Stack sx={{ minWidth: 96 }}>
        <Typography variant="body2" color="text.secondary">
          {label}
        </Typography>
      </Stack>
      <Stack sx={{ flexGrow: 1, minWidth: 0 }}>{children}</Stack>
    </Stack>
  );
}

/** A figure that opens the tab it belongs to, so the summary is the way into the detail. */
export function SummaryCount({ n, onOpen }: { n: number; onOpen?: () => void }) {
  return onOpen ? (
    <Link
      component="button"
      type="button"
      variant="body2"
      onClick={onOpen}
      sx={{ width: 'fit-content' }}
    >
      {n}
    </Link>
  ) : (
    <Typography variant="body2">{n}</Typography>
  );
}
